export default "/images/mccarran.svg?196372d379e9af162b37264b46ed4ba8";